export const checksums = {
  "index": "v3.5.0--ebvTRskmkHk9pnHuKE0ZQi7g8phl7wkgZY38xghFLiI",
  "docsv3": "v3.5.0--lHMfuFWulPzvjUo-Jgn-4-moKIhfP628jPEyXHF7HfQ",
  "docsv4": "v3.5.0--3FlvqBF24vs6IMiqKMi1woQeV8oDKf3GBd9gGaX96k8",
  "blog": "v3.5.0--TUvZ0ChbjINsWkhCYIZhX9j5Qnqi8y8vZ8uM_i0_Md8",
  "landing": "v3.5.0--h7RTpSTrupQC7o4gqPRIaJq5H4krXipKzuCzeFEne2M",
  "deploy": "v3.5.0--_g8KzmJsYV1GHimtTZgfKHTf_OzmetDAefvLtYDAyj8",
  "manualSponsors": "v3.5.0--FAlqPLWoGQ7fSncP03JOGG8CHRQGbJoge3mKQpwoccY",
  "support": "v3.5.0--PTGbkKlMWBj2Uj_Fe9NB-C2HMichmmEq-Dtg3B0uGaA",
  "agencies": "v3.5.0--MhaYr4qQinhvkV6M3V3HxYs69bh4qiJsYujPmLbYC7w",
  "templates": "v3.5.0--3o8hJbKXIvkfJeXm6Ihpwcapqh88ss-uv7Vvy_uNDmM",
  "showcase": "v3.5.0--BOYKyn_SkRvhP51XexeCa7eo0mz4GvFyOtSTcvS9PRk",
  "videoCourses": "v3.5.0--SaVQahzCOMWuX_dyYniFSt17FjoYVKXZseDnVwH2Thk",
  "designKit": "v3.5.0--10RRgIBwAnh7TVVDHbhXlOX7OXedL6aj28Kvj7d6CDU",
  "team": "v3.5.0--nSgA6MaZgS5cBbx7rudo-jK_lEzdaBgKyGOAHdfTOcE"
}
export const checksumsStructure = {
  "index": "rbMG1eOiUTNGy_xyk9VPcrt70I6t8ckzwxQB33q9CGk",
  "docsv3": "rkw3JY8nBFL9jBjiyqBfGx0oDNwnW5ntjbrgkTlGIPw",
  "docsv4": "5sf5xuLFLUh4vqoW8rc7pR2H6m8NSJQYZAdGmkWaT_I",
  "blog": "ZYOyP0HzuupsGyuDJ0jW3G4W9GJnMCcrYHIUiYQNkmI",
  "landing": "rJ389Ea_TupBiPEM_ltxLvb4bcdeovLQ-AzrE7Q_QzQ",
  "deploy": "PSPDIoGKVQgVA3vA67GTmyfUK6DM_qcZ4VLapjn7MXA",
  "manualSponsors": "hNm7u_hUfJaLUtob_rlt7cFwObGEnvQVvJJybVYfEgg",
  "support": "euT2wOQwCvsmZlUf2kN5TQrPUAgcNPAPR4klmLsG13w",
  "agencies": "AZBiQC6U2yTzFqAEigeawd0imxPnvfPcLSxKGaU3FqU",
  "templates": "mOhfHlGbIfAFAONJdvsgJQxXSpoDswEcBBuK0IKxtxo",
  "showcase": "GS-EyXqKNXTznwMumU0vtQ1D0_OStp5z2_kiAS1Ittw",
  "videoCourses": "wJKAQGHX09gpxMMnLo9zJN_o1C6fSFzijucqsfoHMSM",
  "designKit": "QhkqnRnEvsBJC94PTxTWnZQByc-2lhyP2l0FdPUhwtw",
  "team": "gYK-0e38oFyVG-erkUhQTjcH3sSIM7poSVHk_G_hXz4"
}

export const tables = {
  "index": "_content_index",
  "docsv3": "_content_docsv3",
  "docsv4": "_content_docsv4",
  "blog": "_content_blog",
  "landing": "_content_landing",
  "deploy": "_content_deploy",
  "manualSponsors": "_content_manualSponsors",
  "support": "_content_support",
  "agencies": "_content_agencies",
  "templates": "_content_templates",
  "showcase": "_content_showcase",
  "videoCourses": "_content_videoCourses",
  "designKit": "_content_designKit",
  "team": "_content_team",
  "info": "_content_info"
}

export default {
  "index": {
    "type": "data",
    "fields": {
      "id": "string",
      "contributors": "json",
      "deploy": "json",
      "extension": "string",
      "features": "json",
      "foundation": "json",
      "hero": "json",
      "logos": "json",
      "meta": "json",
      "modules": "json",
      "sponsors": "json",
      "stats": "json",
      "stem": "string",
      "support": "json",
      "testimonial": "json"
    }
  },
  "docsv3": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "description": "string",
      "extension": "string",
      "links": "json",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string",
      "titleTemplate": "string"
    }
  },
  "docsv4": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "description": "string",
      "extension": "string",
      "links": "json",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string",
      "titleTemplate": "string"
    }
  },
  "blog": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "authors": "json",
      "body": "json",
      "category": "string",
      "date": "string",
      "description": "string",
      "draft": "boolean",
      "extension": "string",
      "image": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string",
      "tags": "json"
    }
  },
  "landing": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "cta": "json",
      "description": "string",
      "extension": "string",
      "head": "json",
      "headline": "json",
      "image": "json",
      "links": "json",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string"
    }
  },
  "deploy": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "category": "string",
      "componentImg": "string",
      "description": "string",
      "extension": "string",
      "featured": "boolean",
      "logoIcon": "string",
      "logoSrc": "string",
      "meta": "json",
      "navigation": "json",
      "nitroPreset": "string",
      "path": "string",
      "seo": "json",
      "stem": "string",
      "website": "string"
    }
  },
  "manualSponsors": {
    "type": "data",
    "fields": {
      "id": "string",
      "extension": "string",
      "meta": "json",
      "sponsors": "json",
      "stem": "string"
    }
  },
  "support": {
    "type": "data",
    "fields": {
      "id": "string",
      "title": "string",
      "description": "string",
      "expertise": "json",
      "extension": "string",
      "form": "json",
      "hero": "json",
      "logos": "json",
      "meta": "json",
      "project": "json",
      "service": "json",
      "stem": "string",
      "testimonials": "json"
    }
  },
  "agencies": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "color": "json",
      "description": "string",
      "emailAddress": "string",
      "extension": "string",
      "github": "string",
      "instagram": "string",
      "link": "string",
      "linkedin": "string",
      "location": "string",
      "logo": "json",
      "logoFull": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "phoneNumber": "string",
      "regions": "json",
      "resources": "json",
      "seo": "json",
      "services": "json",
      "stem": "string",
      "x": "string"
    }
  },
  "templates": {
    "type": "data",
    "fields": {
      "id": "string",
      "badge": "string",
      "demo": "string",
      "description": "string",
      "extension": "string",
      "featured": "boolean",
      "meta": "json",
      "name": "string",
      "purchase": "string",
      "repo": "string",
      "screenshotOptions": "json",
      "screenshotUrl": "string",
      "slug": "string",
      "stem": "string"
    }
  },
  "showcase": {
    "type": "data",
    "fields": {
      "id": "string",
      "title": "string",
      "description": "string",
      "extension": "string",
      "head": "json",
      "meta": "json",
      "stem": "string",
      "websites": "json"
    }
  },
  "videoCourses": {
    "type": "data",
    "fields": {
      "id": "string",
      "badge": "string",
      "description": "string",
      "extension": "string",
      "meta": "json",
      "name": "string",
      "screenshotOptions": "json",
      "screenshotUrl": "string",
      "slug": "string",
      "sponsor": "boolean",
      "stem": "string",
      "url": "string"
    }
  },
  "designKit": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "cta": "json",
      "description": "string",
      "extension": "string",
      "head": "json",
      "headline": "json",
      "image": "json",
      "links": "json",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string"
    }
  },
  "team": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "cta": "json",
      "description": "string",
      "extension": "string",
      "head": "json",
      "headline": "json",
      "image": "json",
      "links": "json",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string",
      "users": "json"
    }
  },
  "info": {
    "type": "data",
    "fields": {}
  }
}